import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const AssetTypeAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    code: '',
    name: '',
    description: '',
    status: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const classList = [
    { key: "STANDARD", value: "STANDARD" },
    { key: "VIRTUAL",  value: "VIRTUAL" }
  ];

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onClassSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, class: key })
  };

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }

  const handleCreateSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name && (objAttrs.name != null) && objAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;

    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (!objAttrs.class || objAttrs.class.length === 0) {
      setErrMsg(t("I18N_ERR_Need_class"));
      return;
    }
/* Not used for now.
    } else if (objAttrs.status.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_status") + 50);
      return;
    }
*/

    // Deep copy
    let tmpAttrs = JSON.parse(JSON.stringify(objAttrs));


    const reqBody = tmpAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.post("asset-types/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Asset_Type")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_type_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Asset_type_code")}: *</Col>
                <Col>{t("I18N_Name")}: *</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Class")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'80px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.class || (objAttrs.class === '') ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.class)}
                    onSelect={onClassSelect}>
                    {classList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("common:I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                <span>{t("I18N_Req_fields")}</span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleCreateCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '15px' }}
                    onClick={handleCreateSubmit}>
                    {t("I18N_Save")}
                  </Button>
                  <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg}
                  </span>
                </div>
              </Row>
            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default AssetTypeAdminNewView;
